export const firebaseConfig = {
  apiKey: "AIzaSyAkBa8L-IaewLwSiFYfzQkO-L7fFhVkYJU",
  authDomain: "key--track.firebaseapp.com",
  projectId: "key--track",
  storageBucket: "key--track.appspot.com",
  messagingSenderId: "590463810088",
  appId: "1:590463810088:web:266faab039b8f31ddd131d",
  measurementId: "G-W2XQYR3H0D",
};
